(function () {
    'use strict';

    function HomeCtrl(restangular, appData, authService, $state, $uibModal, $scope, $window, trackingService) {
        var vm = this;

        vm.searchOptions = {
            term: ''
        };   

        vm.showResults = function () {
            return vm.searchOptions.term !== '';
        }

        restangular.all('categories').one('secondary').getList().then(function (data) {
            vm.secondaryCategories = _.sortBy(data, 'name');
        });

        restangular.all('categories').one('primary').getList().then(function (data) {
            vm.primaryCategories = data;
        });
        
        vm.filterDocuments = function (primaryCategory, secondaryCategory) {
            return _.filter(vm.documents, function (document) {
                return document.primaryCategory === primaryCategory && document.secondaryCategory === secondaryCategory.name;
            });
        };

        vm.filterCategories = function (primaryCategory) {
            vm.filteredCategories  = _.filter(vm.secondaryCategories, function (o) { return o.primaryCategory == primaryCategory; });
        }

        function fetch() {
            restangular
                .one('documents')
                .one('all')
                .get(vm.searchOptions)
                .then(function (data) {
                    vm.documents = data;
                    vm.filterCategories('COM 2000/3000');
                });
        };

        $scope.$watch(function () { return vm.searchOptions; }, fetch, true);

        vm.documentDownload = function(document) {
            trackingService.trackEvent(document.name);
            $window.location = document.downloadLink + '?token=' + authService.authentication.token;
        }

        vm.documentClick = function(document) {
            if (document.isStreamable) {
                trackingService.trackEvent(document.name, 'View');
                playVideo(document);
                return;
            }
            trackingService.trackEvent(document.name, 'Download');
            $window.open(document.downloadLink + '?token=' + authService.authentication.token);
        }

        function playVideo(document){
            $uibModal.open({
                templateUrl: 'home/video.html',
                controller: ['$scope', 'document',
                    function ($scope, document) {
                        $scope.name = document.name;
                        $scope.videoUrl = document.streamLink + '?token=' + authService.authentication.token;
                    }],
                resolve: {
                    document: function() {
                        return document;
                    }
                },
                size: 'lg',
                backdrop: true
            });
        }
    };

    angular
        .module('app')
        .controller('HomeCtrl', ['Restangular', 'appData', 'authService', '$state', '$uibModal', '$scope', '$window', 'trackingService', HomeCtrl]);

})();